import { useState, useContext } from "react";
// Import Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";
// Hooks
import { useDeleteDraftOrder } from "../../hooks/useDeleteDraftOrder";
import { useCheckAPI } from "../../hooks/useCheckAPI";
// MUI
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export const DeleteDraftOrderDialog = ({ orderNo, disabled }) => {
  const { mutate, isSuccess, data } = useDeleteDraftOrder();
  const [open, setOpen] = useState(false);
  const { setAlertNotification } = useContext(AlertNotificationContext);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    mutate({
      data: {
        filter: { noFilter: orderNo },
      },
    });
  };

  // API call success
  const successFunc = () => {
    setOpen(false);
    setAlertNotification({
      message: `${orderNo} deleted`,
      severity: "info",
    });
  };

  // API call error
  const errorFunc = () =>
    setAlertNotification({
      message: `Error: ${data.data.status}: ${data.data.statusText}`,
      severity: "warning",
    });

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <Box>
      <IconButton
        aria-label="delete-order"
        color="error"
        onClick={handleClickOpen}
        disabled={disabled}
      >
        <DeleteIcon />
      </IconButton>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={handleClose}
        aria-labelledby="delete-order-dialog"
      >
        <DialogTitle id="delete-order-dialog-title">
          Delete {orderNo}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete {orderNo}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleDelete}>Delete</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
